import ProjectCard from "../Elements/ProjectCard";
import Carousel from "react-grid-carousel";
import 'react-multi-carousel/lib/styles.css';
import productData from "../../content.json";


const ProjectSection = () => {
  // const responsive = {
  //   superLargeDesktop: {
  //     // the naming can be any, depends on you.
  //     breakpoint: { max: 4000, min: 1024 },
  //     items: 3,
  //     slidesToSlide: 3,
  //   },
  //   desktop: {
  //     breakpoint: { max: 1024, min: 800 },
  //     items: 3,
  //   },
  //   tablet: {
  //     breakpoint: { max: 800, min: 464 },
  //     items: 2,
  //   },
  //   mobile: {
  //     breakpoint: { max: 464, min: 0 },
  //     items: 1,
  //   },
  // };

  const product = productData.map((item, index) => (
    <Carousel.Item key={index}>
    <ProjectCard
      refpage = {item.refpage}
      imgsource = {item.imgsource}
      title  = {item.title}
      filter = {item.filter}
      content = {item.content}
      hashtag = {item.hashtag}
      imgcredit = {item.imgcredit}
      imgcreditlink = {item.imgcreditlink}
    />
  </Carousel.Item>
  ))
    return (
        <section id="projects">
        <div className="container">
          <div className="row text-center justify-content-center mb-1">
            <div className="col">
              <h2 className="mb-3 mt-1" styles={{fontSize: '50px'}}>My Projects</h2>
            </div>
          </div>
          <Carousel cols={3} rows={3} gap={10} loop = {false} showDots = {true} >
            {product}
          </Carousel>
        </div>
      </section>
    )

}

export default ProjectSection;